import AuthOmhulsel from '../components/AuthOmhulsel';
import { Knop } from '../components/ui';
import { Symbool } from '../components/icons';
import { useAuth } from '../lib/auth';

/**
 * Het scherm tussen aanmelden en meedoen. Een vers account heeft de rol
 * `aangevraagd` en krijgt van de database niets te zien — dat is geen storing
 * maar de bedoeling, dus dat leggen we hier uit.
 */
export default function WachtOpGoedkeuring() {
  const { profile, session, signOut, herlaadProfiel } = useAuth();
  const geweigerd = profile?.role === 'geweigerd';


  return (
    <AuthOmhulsel>
      <Symbool naam={geweigerd ? 'verbod' : 'klok'} className="!h-8 !w-8 text-krijt-400" />

      {geweigerd ? (
        <>
          <h1 className="mt-3 font-display text-[32px] leading-tight">Geen toegang</h1>
          <p className="mt-3 text-sm leading-relaxed text-krijt-600">
            Je aanvraag is afgewezen. Denk je dat dat een vergissing is, vraag dan iemand van kantoor om je account
            alsnog vrij te geven.
          </p>
        </>
      ) : (
        <>
          <h1 className="mt-3 font-display text-[32px] leading-tight">Je staat op de lijst</h1>
          <p className="mt-3 text-sm leading-relaxed text-krijt-600">
            Je account is aangemaakt{profile?.name ? `, ${profile.name}` : ''}. Een beheerder moet je nog vrijgeven —
            even iemand aanstoten helpt meestal sneller dan wachten.
          </p>
        </>
      )}

      <p className="mt-4 text-xs text-krijt-500">{session?.user.email}</p>

      <div className="mt-6 flex gap-2">
        {geweigerd ? null : <Knop onClick={() => void herlaadProfiel()}>Opnieuw kijken</Knop>}
        <Knop variant="stil" onClick={() => void signOut()}>
          Uitloggen
        </Knop>
      </div>
    </AuthOmhulsel>
  );
}
